var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x8F\x90\xE4\xBA\xA4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x8F\x90\xE4\xBA\xA4\xE5\x8F\x91\xE5\xB8\x83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M10.399 5.42876H13.1423L9.71387 2V4.74355C9.71387 5.12169 10.0209 5.42876 10.399 5.42876Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73583 4.78646C8.73583 5.24103 8.9155 5.67683 9.23729 5.99866C9.55908 6.32048 9.99484 6.50017 10.4494 6.50017H13.1403V12.2863C13.1403 12.7409 12.9607 13.1767 12.6389 13.4985C12.3171 13.819 11.8813 14 11.4268 14H4.56998C4.11545 14 3.67969 13.8203 3.3579 13.4985C3.03745 13.1767 2.85645 12.7409 2.85645 12.2863V3.71371C2.85645 3.25913 3.03611 2.82333 3.3579 2.50151C3.67969 2.18102 4.11545 2 4.56998 2H8.73583V4.78646ZM9.21584 9.03185C9.34991 9.01978 9.46388 8.93396 9.51483 8.81059C9.56712 8.68857 9.54567 8.54643 9.4612 8.44452L7.2328 5.78679H7.26632C7.20732 5.7117 7.11749 5.66879 7.02229 5.66879C6.9271 5.66879 6.83727 5.71304 6.77827 5.78679L4.58071 8.44452C4.49624 8.54777 4.47613 8.68857 4.52708 8.81193C4.57803 8.93396 4.69333 9.01978 4.82473 9.03319H6.17893V11.9752C6.17893 12.2072 6.36799 12.3962 6.59994 12.3962H7.44062C7.67258 12.3962 7.86163 12.2072 7.86163 11.9752V9.03185H9.21584Z",
    fill: "#787878"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/提交.6f9534da0e66fa1ac7763e24c6920154.svg";
export { ForwardRef as ReactComponent };